import 'lightgallery/dist/js/lightgallery.js';
import 'lg-fullscreen/dist/lg-fullscreen.js';
import 'lg-thumbnail/dist/lg-thumbnail.js';
import 'lg-zoom/dist/lg-zoom.js';
import objectFitImages from 'object-fit-images';

export default {
  init() {
    // JavaScript to be fired on all pages

    objectFitImages();

  },
  finalize() {
    if ( $('.woocommerce-product-gallery').length ) {
      $('.woocommerce-product-gallery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: '.woocommerce-product-gallery__wrapper .slider-nav',
        arrows: false,
        dots: false,
        draggable: false,
        asNavFor: '.product-thumbnails',
      });
    }

    if ( $('.product-thumbnails').length ) {
      $('.product-thumbnails').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        asNavFor: '.woocommerce-product-gallery',
        centerMode: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 479,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    $('.woocommerce-product-gallery').lightGallery({
			selector: '.slick-slide:not(.slick-cloned) .woocommerce-product-gallery__image > a',
		});
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-product.js